export const Sizes = {
	smaller:		"0.75rem",
	small: 			"0.875rem",
	normal:			"1rem",
	big:				"1.125rem",
	bigger:			"1.25rem",
	titan:			"1.5rem",
}